import classNames from 'classnames';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Button from 'components/base/Button';
import { errorHandler } from 'helpers/response-utils';
import { parseData } from 'helpers/utils';
import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode';

const Wallet = () => {
  const nav = useNavigate();
  const userJSON = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  const [copySuccess, setCopySuccess] = useState('');
  const [qrCodeImage, setQrCodeImage] = useState('');
  const [wallet, setWallet] = useState({
    address: '',
    walletNativeBalance: '0',
    walletBalance: '0'
  });

  useEffect(() => {
    getActiveWallet();
  }, []);

  const getActiveWallet = async () => {
    const user = userJSON != null ? parseData(userJSON) : '';

    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/flywheel-wallet`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    errorHandler(response);

    if (response.data['data']['wallet']) {
      setWallet(response.data['data']['wallet']);
      setQrCodeImage(
        await QRCode.toDataURL(response.data['data']['wallet']['address'])
      );
    }
  };

  const handleCopy = () => {
    const address = wallet['address'];
    if (!address) return;

    navigator.clipboard
      .writeText(address)
      .then(() => {
        setCopySuccess('Copied!');
        setTimeout(() => setCopySuccess(''), 2000);
      })
      .catch(() => setCopySuccess('Failed to copy'));
  };

  return (
    <div>
      <div className="mb-6">
        <Row className="g-3 justify-content-between mb-4">
          <Col xs="auto">
            <h2>Flywheel Wallet</h2>
          </Col>
        </Row>
        {Object.keys(wallet).length ? (
          <Row>
            <Col className="col-6">
              <Card>
                <Card.Body>
                  <Row className={classNames('g-3', 'mb-6')}>
                    <Col sm={12} md={12}>
                      Wallet address
                      <p>
                        <Button variant="secondary" onClick={handleCopy}>
                          {wallet['address']}
                        </Button>
                        {copySuccess && (
                          <span className="ms-2">{copySuccess}</span>
                        )}
                      </p>
                    </Col>
                    <Col sm={12} md={12}>
                      Sol Balance
                      <p>
                        <b>{wallet['walletNativeBalance']}</b> SOL
                      </p>
                    </Col>
                    <Col sm={12} md={12}>
                      WMDR Balance
                      <p>
                        <b>{wallet['walletBalance']}</b> WMDR
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col className="col-6">
              <Card>
                <Card.Body>
                  <Row>
                    <Col sm={12} md={12}>
                      <a href={qrCodeImage} download={wallet['address']}>
                        <img src={qrCodeImage} alt="" className="w-50" />
                      </a>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col className="col-6">
              <p>No Record Found</p>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default Wallet;
